import { createPropType } from '../utils';

export default createPropType(function (props, propName, componentName) {
  var value = props[propName];

  if (!(value instanceof RegExp)) {
    return new Error('Invalid prop ' + propName + ' of ' + componentName + ', should be valid regex.');
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/libs/props/regex.js
// module id = 321
// module chunks = 0